import { useEffect, useRef, useCallback } from 'react';

const LOBBY_MUSIC_PATH = '/audio/jeopardy-theme.mp3';

export const useLobbyMusic = (isPlaying: boolean) => {
  const audioRef = useRef<HTMLAudioElement | null>(null);
  const hasInteractedRef = useRef(false);

  // Initialize audio element
  useEffect(() => {
    const audio = new Audio(LOBBY_MUSIC_PATH);
    audio.loop = true;
    audio.volume = 0.5;
    audioRef.current = audio;

    return () => {
      audio.pause();
      audio.src = '';
      audioRef.current = null;
    };
  }, []);

  // Handle play/pause based on isPlaying state
  useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return;

    if (isPlaying) {
      // Try to play - may fail due to autoplay policy
      const playPromise = audio.play();
      if (playPromise !== undefined) {
        playPromise.catch((error) => {
          // Autoplay was prevented - will need user interaction
          console.log('Lobby music autoplay prevented:', error.message);
        });
      }
    } else {
      audio.pause();
      audio.currentTime = 0;
    }
  }, [isPlaying]);

  // Allow manual start (for after user interaction)
  const startMusic = useCallback(() => {
    const audio = audioRef.current;
    if (audio && !hasInteractedRef.current) {
      hasInteractedRef.current = true;
      audio.play().catch(console.error);
    }
  }, []);

  // Allow volume control
  const setVolume = useCallback((volume: number) => {
    const audio = audioRef.current;
    if (audio) {
      audio.volume = Math.max(0, Math.min(1, volume));
    }
  }, []);

  return {
    startMusic,
    setVolume,
  };
};




